var render = function render(){var _vm=this,_c=_vm._self._c;return _c('forgot-password',{attrs:{"action":"/manager/reset-password"},scopedSlots:_vm._u([{key:"backToLogin",fn:function(){return [_c('router-link',{attrs:{"to":{ name: 'platform-login' }}},[_c('font-awesome-icon',{attrs:{"icon":"arrow-left"}}),_c('span',{staticClass:"back-to-login"},[_vm._v("Back to Sign In")])],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }